import { createContext } from "react";

const scrollContext = createContext({});

export default scrollContext;